import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import sweetalert from 'sweetalert2'
import KanBoIcon from 'components/KanBoIcon'
import User from 'components/User'
import BoardUser from 'routes/Board/User'

export class CardUser extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,

    intl: PropTypes.object.isRequired,

    requestMakeUserResponsible: PropTypes.func.isRequired,
    requestRemoveUser: PropTypes.func.isRequired
  }

  static userStyle = { marginRight: 5, marginBottom: 5 }

  renderUserComponent = ({
    intl,
    isArchived,
    permission,
    isResponsible,
    isLastMember,
    id,
    isActive,
    menu,

    requestMakeUserResponsible,
    requestRemoveUser,

    ...props
  }) => {
    let _menu = []

    if (!isArchived && permission.member) {
      if (!isResponsible && isActive) {
        _menu.push({
          icon: <KanBoIcon fixedWidth name='kanbo-16-solid-star' />,
          title: <FormattedMessage id='CARD_PROMOTE_USER' />,
          onClick: () => requestMakeUserResponsible({
            cardId: this.props.cardContext.id,
            userId: id
          })
        })
      }

      _menu.push({
        icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
        title: <FormattedMessage id='CARD_REMOVE_USER' />,
        onClick: () => {
          if (isResponsible && !isLastMember) {
            sweetalert({
              text: intl.formatMessage({ id: 'CARD_REMOVE_USER_VALIDATE' }),
              type: 'info'
            })
          } else {
            requestRemoveUser({
              cardId: this.props.cardContext.id,
              userId: id
            })
          }
        }
      })
    }

    return (
      <User
        {...props}
        id={id}
        isActive={isActive}
        menu={_menu}
        draggable={isActive && permission.member}
        style={!isResponsible ? CardUser.userStyle : null}
      />
    )
  }

  render () {
    return (
      <BoardUser
        {...this.props}
      >
        {this.renderUserComponent}
      </BoardUser>
    )
  }
}

export default injectIntl(CardUser)